var map = {
	"./address-empty.png": 3221,
	"./blank-content.png": 613,
	"./error-server.png": 3823,
	"./goods-empty.png": 5449,
	"./goods_detail_placeholder.png": 622,
	"./no-data.png": 2798,
	"./off-line.png": 7817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3085;